import { render, staticRenderFns } from "./PreviewDelivery.vue?vue&type=template&id=6f6723a5&scoped=true&"
import script from "./PreviewDelivery.vue?vue&type=script&lang=js&"
export * from "./PreviewDelivery.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDelivery.vue?vue&type=style&index=0&id=6f6723a5&lang=scss&scoped=true&"
import style1 from "./PreviewDelivery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6723a5",
  null
  
)

export default component.exports